/**
 * Custom page UI style
 */
import { styled } from '@mui/material/styles';
import { Container, Typography, CircularProgress } from '@mui/material';

// custom style for centraling content element
export const CenterContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  textAlign: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

/**
 * @param {string} message
 * @returns Empty Page UI message
 */
export function EmptyPageUI(message = 'Nessun risultato trovato') {
  return (
    <Container>
      <CenterContent>
        <Typography variant="subtitle1">{message}</Typography>
      </CenterContent>
    </Container>
  );
}

/**
 * @returns Loading component UI
 */
export function LoadingUI() {
  return (
    <Container>
      <CenterContent>
        <CircularProgress />
      </CenterContent>
    </Container>
  );
}
